// src/core/hooks/use-site-settings.ts
'use client';

import { useEffect, useState } from 'react';
import { getSettings } from '@/core/lib/api/main/setting';
import { Settings } from '@/core/models/settings-model';

// برای کامپوننت‌های کلاینتی که به تنظیمات سایت (مثلاً discount_display_active) نیاز
// دارن ولی خودشون سرور کامپوننت نیستن که مستقیم getSettings رو await کنن.
export function useSiteSettings() {
  const [settings, setSettings] = useState<Settings>();

  useEffect(() => {
    getSettings().then(setSettings).catch(console.error);
  }, []);

  return settings;
}
